<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer001" style="height:0pt"></div><div class="basic-text-frame" id="_idContainer047">
<p class="copyrightpage"><span id="calibre_toc_2">Copyright</span> © 2019 by Sean Covey.<br class="calibre1"/>Published by Mango Publishing Group, a division of Mango Media<span class="nobreak"> </span>Inc.</p>
<p class="copyrightpage">Cover Design: Morgane Leoni<br class="calibre1"/>Cover illustration: Tortuga - Shutterstock<br class="calibre1"/>Layout &amp; Design: Roberto Núñez<br class="calibre1"/>Illustrations: MicroOne - Shutterstock</p>
<p class="copyrightpage">Mango is an active supporter of authors’ rights to free speech and artistic expression in their books.  The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open<span class="nobreak"> </span>society.</p>
<p class="copyrightpage">Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property.  Please honor the author’s work as you would your own. Thank you in advance for respecting our author’s<span class="nobreak"> </span>rights.</p>
<p class="copyrightpage">For permission requests, please contact the publisher at:<br class="calibre1"/>Mango Publishing Group<br class="calibre1"/>2850 S Douglas Road, 2nd Floor<br class="calibre1"/>Coral Gables, FL 33134 USA<br class="calibre1"/><a href="mailto:info@mango.bz">info@mango.bz</a></p>
<p class="copyrightpage">For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at <a href="mailto:sales@mango.bz">sales@mango.bz</a>.  For trade and wholesale sales, please contact Ingram Publisher Services at <a href="mailto:customer.service@ingramcontent.com">customer.service@ingramcontent.com</a> or +1.800.509.4887.</p>
<p class="copyrightpage">Navigating College With the 7 Habits: A Digital Book to Help You Succeed In School and in<span class="nobreak"> </span>Life</p>
<p class="copyrightpage">ISBN: (ebook) 978-1-64250-178-0<br class="calibre1"/>BISAC category code SELF-HELP / Personal Growth / Success</p>
<p class="copyrightpage">Printed in the United States of<span class="nobreak"> </span>America</p>
<div class="calibre2" id="calibre_pb_3"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_001.vue?62f893f9